import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Type } from '@nerdwallet/currency';
import HtmlToNDS from '@nerdwallet/react-html-to-nds';
import nds from '@nerdwallet/base-styles/classes';

import Row from '../../row/row';

const StatTable = ({ drivers, featuredCard }) => (
  <Row
    className={classNames('stat-table', {
      [nds('border-neutral-lighter')]: !featuredCard,
      [nds('background-neutral-lightest')]: !featuredCard,
      [nds('border-blue-lighter')]: featuredCard,
      [nds('background-blue-lightest')]: featuredCard,
    })}
  >
    {drivers.map((driver) => {
      const { titleText, item, subItem } = driver;

      return (
        <div
          className={classNames('stat-table__box', {
            [nds('border-neutral-lighter')]: !featuredCard,
            [nds('border-blue-lighter')]: featuredCard,
          })}
          key={driver.titleText}
        >
          <Type size={1} bold className="stat-table__box__title">
            {titleText}
          </Type>
          <Row>
            {item ? (
              <Type size={1} className="stat-table__box__main-content">
                {item}
              </Type>
            ) : null}
            <div className="stat-table__box__subtext">
              <HtmlToNDS html={subItem} />
            </div>
          </Row>
        </div>
      );
    })}
  </Row>
);

StatTable.propTypes = {
  drivers: PropTypes.arrayOf(
    PropTypes.shape({
      titleText: PropTypes.string,
      item: PropTypes.string,
      subItem: PropTypes.string,
    })
  ).isRequired,
  featuredCard: PropTypes.bool,
};

StatTable.defaultProps = {
  drivers: [],
  featuredCard: false,
};

export default StatTable;
